module.exports = __webpack_public_path__ + "img/4.1b827dd1.jpg";